import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Avatar, Box, IconButton, MenuItem, Popover, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { removeToken, removeUser } from "../../services/authService";
import { getUser } from '../../services/authService';
import { tokens } from '../../theme';

const Topbar = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [anchorEl, setAnchorEl] = useState(null);
  
  // 현재 사용자 정보 가져오기
  const currentUser = getUser();
  const isAdmin = currentUser?.grade === 'admin';
  
  // 아바타에 표시할 텍스트 (관리자는 AD, 에이전트는 AG)
  const avatarText = isAdmin ? 'AD' : 'AG';

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickLogout = () => {
    removeToken();
    removeUser();
    setAnchorEl(null);

    navigate("/");
  };

  const open = Boolean(anchorEl);

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      p={2}
      sx={{
        background: "linear-gradient(145deg, rgba(25,25,38,1) 0%, rgba(25,32,48,1) 100%)",
        boxShadow: "0 4px 6px"
      }}
    >
      {/* ICONS */}
      <Box display="flex" alignItems="center" gap={2}>
        <IconButton
          onClick={handleProfileClick}
          sx={{
            color: "#ffffff",
            "&:hover": {
              transform: "scale(1.1)",
              transition: "all 0.3s ease",
            },
          }}
        >
          <PersonOutlinedIcon />
        </IconButton>
      </Box>

      {/* PROFILE POPOVER */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPaper-root": {
            background: "linear-gradient(145deg, rgba(25,25,38,1) 0%, rgba(25,32,48,1) 100%)",
            borderRadius: "12px",
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
            padding: "16px",
            width: "250px",
          },
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          <Avatar
            sx={{
              bgcolor: isAdmin ? colors.greenAccent[500] : colors.blueAccent[500],
              width: 56,
              height: 56,
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            {avatarText}
          </Avatar>
          <Typography variant="h6" color="#ffffff">
            {isAdmin ? '관리자' : `${currentUser?.id || '에이전트'}`}
          </Typography>
          <Typography variant="body2" color={colors.grey[300]}>
            {isAdmin ? '관리자' : '에이전트'}
          </Typography>
          
          {/* 마이페이지 메뉴 아이템 (에이전트만 표시) */}
          {!isAdmin && (
            <MenuItem
              sx={{
                mt: 1,
                color: "#ffffff",
                justifyContent: "center",
                borderRadius: "8px",
                background: "transparent",
                "&:hover": {
                  background: "rgba(255, 255, 255, 0.1)",
                  color: "#ffffff",
                  transition: "all 0.3s ease",
                },
                width: "100%",
              }}
              onClick={() => {
                navigate("/my");
                handleClose();
              }}
            >
              <AccountCircleOutlinedIcon sx={{ mr: 1 }} />
              마이페이지
            </MenuItem>
          )}
          
          {/* 로그아웃 메뉴 아이템 */}
          <MenuItem
            sx={{
              mt: 1,
              color: "#ffffff",
              justifyContent: "center",
              borderRadius: "8px",
              background: "transparent",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.1)",
                color: "#ffffff",
                transition: "all 0.3s ease",
              },
              width: "100%",
            }}
            onClick={onClickLogout}
          >
            <LockOutlinedIcon sx={{ mr: 1 }} />
            로그아웃
          </MenuItem>
        </Box>
      </Popover>
    </Box>
  );
};

export default Topbar;